/*
 * @Author: lubo10 lubo10@hikvision.com.cn
 * @Date: 2022-12-01 15:14:03
 * @LastEditors: lubo10 lubo10@hikvision.com.cn
 * @LastEditTime: 2023-01-17 15:05:12
 * @FilePath: \city-h5\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import 'weui'
import App from './App.vue'
import router from './route/router'
import store from './store/index.js'
import wx from 'weixin-js-sdk'
import viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import { Button, Cell, CellGroup, ActionSheet, RadioGroup, Radio, Form, Field, Uploader, Icon, Swipe, SwipeItem, Tag, Image as VanImage, PasswordInput,List ,PullRefresh} from 'vant'
global.wx = wx

Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(ActionSheet)
Vue.use(Field)
Vue.use(Form)
Vue.use(Uploader)
Vue.use(Icon)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Tag)
Vue.use(VanImage)
Vue.use(PasswordInput)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(viewer)
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp']
new Vue({
  router,
  store,
  viewer,
  render: h => h(App)
}).$mount('#app')
